var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nutbody"},[_c('keep-alive',[_c('router-view',{attrs:{"urlBase":_vm.urlBase,"token":_vm.token,"username":_vm.username}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }